var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1024 1024",
    height: 1024,
    width: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1533_112684)",
    d: "M550.823 389.845H472.408V468.26H550.823V389.845Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FEE4C3",
    transform: "matrix(0.596845 0.802357 0.802357 -0.596845 486.953 696.345)",
    height: 48.1479,
    width: 36.1109
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M580.013 727.16C591.364 718.792 582.239 704.36 568.85 686.199C555.462 668.037 541.154 648.628 525.792 653.608C526.47 653.399 514.541 655.558 511.3 676.98C511.3 676.98 528.61 683.25 532.511 705.753C547.492 719.469 571.558 733.393 580.013 727.16Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FEE4C3",
    transform: "rotate(126.644 542.746 696.345)",
    height: 48.1479,
    width: 36.1109,
    y: 696.345,
    x: 542.746
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M449.686 727.16C438.335 718.792 447.461 704.36 460.849 686.199C474.237 668.037 488.545 648.628 503.907 653.608C503.229 653.399 515.159 655.558 518.4 676.98C518.4 676.98 501.089 683.25 497.189 705.753C482.207 719.469 458.141 733.393 449.686 727.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D5D5",
    d: "M524.956 721.502C525.9 716.56 511.389 692.3 497.232 685C442.376 716.448 333.137 781.252 335.024 788.889C337.384 798.436 376.906 800.682 389.881 797.874C428.221 793.943 523.777 727.679 524.956 721.502Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M333.373 785.846C315.512 749.103 360.803 667.837 397.8 628.925C441.815 605.323 525.382 569.079 525.382 628.926C525.382 697.817 355.7 831.775 333.373 785.846Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D5D5",
    d: "M504.743 721.502C503.799 716.56 518.311 692.3 532.467 685C587.323 716.448 696.563 781.252 694.675 788.889C692.316 798.436 652.793 800.682 639.818 797.874C601.478 793.943 505.923 727.679 504.743 721.502Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M696.326 785.846C714.187 749.103 668.897 667.837 631.899 628.925C587.884 605.323 504.318 569.079 504.318 628.926C504.318 697.817 674 831.775 696.326 785.846Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1533_112684)",
    d: "M476.641 416C488.549 427.374 519.511 444.056 548.091 419.791C585.415 430.189 601.685 479.757 608.135 499.408C608.741 501.253 609.26 502.835 609.702 504.095C624.847 547.306 640 610.82 640 631.034C640 641.78 578.051 642.207 513.402 639.802C449.932 642.206 390 641.781 390 631.043C390 610.848 398.423 545.007 413.703 501.838C414.023 500.933 414.387 499.872 414.798 498.674C417.961 489.45 423.899 472.135 434.006 455.902C437.198 446.532 441.138 439.308 446.019 434.957C462.355 420.394 474.939 416 476.641 416Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB955B",
    d: "M559.667 448.745C559.667 448.745 554.186 443.447 548.705 443.448C519.183 471.987 485.745 452.154 471.977 438.152C471.46 437.605 466.496 438.148 461.016 443.447C509.245 485.832 546.878 464.64 559.667 448.745Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE0BC",
    d: "M593.834 408.43C600.401 411.083 609.317 404.344 613.748 393.376C618.179 382.409 616.448 371.367 609.881 368.714C603.314 366.061 594.398 372.801 589.967 383.768C585.536 394.736 587.267 405.777 593.834 408.43Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE0BC",
    d: "M430.754 408.307C424.234 411.074 415.202 404.491 410.58 393.603C405.959 382.716 407.497 371.646 414.017 368.878C420.537 366.111 429.569 372.694 434.19 383.582C438.812 394.469 437.273 405.539 430.754 408.307Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1533_112684)",
    d: "M514.78 461.003C562.628 461.003 601.416 422.781 601.416 375.632C601.416 328.483 562.628 290.261 514.78 290.261C466.933 290.261 428.145 328.483 428.145 375.632C428.145 422.781 466.933 461.003 514.78 461.003Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1533_112684)",
    d: "M598.929 381.702C629.923 340.377 614.427 237.063 511.113 237.063C407.799 237.063 387.137 345.542 428.463 381.702C443.959 335.211 583.431 335.211 598.929 381.702Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#585449",
    d: "M616.979 333.166C615.066 377.819 567.657 326.787 509.175 326.787C450.694 326.787 400.096 382.922 401.371 326.787C401.371 267.601 452.607 226 511.089 226C569.57 226 619.513 274.034 616.979 333.166Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#747169",
    d: "M613.153 346.562C613.153 357.484 566.601 354.855 509.176 354.855C451.751 354.855 405.199 357.484 405.199 346.562C405.199 335.641 451.751 319.133 509.176 319.133C566.601 319.133 613.153 335.641 613.153 346.562Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_1533_112684)",
    d: "M435.677 300.581C430.548 302.534 427.622 292.941 420.771 304.956C417.221 311.181 417.872 351.832 431.95 353.943C446.027 356.054 463.842 352.631 466.782 333.024C497.958 301.056 462.543 266.35 435.677 300.581Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_1533_112684)",
    d: "M445.758 474.116C438.02 505.284 440.81 516.416 427.931 534.477L427.93 534.478C403.53 551.271 376.494 553.728 356.17 519.45C339.115 490.684 392.624 373.739 422.109 315.842C427.123 317.124 442.784 322.728 465.313 334.896C453.966 384.846 453.496 442.949 445.758 474.116Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_1533_112684)",
    d: "M589.323 300.581C594.452 302.534 597.378 292.941 604.229 304.956C607.779 311.181 607.128 351.832 593.05 353.943C578.973 356.054 561.158 352.631 558.218 333.024C527.042 301.056 562.457 266.35 589.323 300.581Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_1533_112684)",
    d: "M579.242 474.116C586.98 505.284 584.19 516.416 597.069 534.477L597.07 534.478C621.47 551.271 648.506 553.728 668.83 519.45C685.885 490.684 632.376 373.739 602.891 315.842C597.877 317.124 582.216 322.728 559.687 334.896C571.034 384.846 571.504 442.949 579.242 474.116Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 468.26,
    x2: 511.616,
    y1: 399.979,
    x1: 511.616,
    id: "paint0_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDA5"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D1",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 665.534,
    x2: 527.523,
    y1: 397.121,
    x1: 599.936,
    id: "paint1_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE194"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF84",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 461.003,
    x2: 514.78,
    y1: 290.261,
    x1: 514.78,
    id: "paint2_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE0BC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 399.48,
    x2: 460.733,
    y1: 282.53,
    x1: 575.089,
    id: "paint3_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636681",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 325.293,
    x2: 422.186,
    y1: 332.949,
    x1: 473.242,
    id: "paint4_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1AC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 489.182,
    x2: 317.763,
    y1: 320.163,
    x1: 474.917,
    id: "paint5_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE194"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF84",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 325.293,
    x2: 602.814,
    y1: 332.949,
    x1: 551.758,
    id: "paint6_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1AC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 489.182,
    x2: 707.237,
    y1: 320.163,
    x1: 550.083,
    id: "paint7_linear_1533_112684"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE194"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF84",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.6eeddd53a63aa170daa7ea4993f97655.svg";
export { ForwardRef as ReactComponent };